var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 27,
    viewBox: "0 0 65 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_8007)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0858 13.9502C65.0858 9.3361 62.8439 5.69531 58.5591 5.69531C54.2562 5.69531 51.6528 9.3361 51.6528 13.9142C51.6528 19.3393 54.7262 22.0788 59.1376 22.0788C61.2891 22.0788 62.9162 21.5922 64.1456 20.9073V17.3025C62.9162 17.9154 61.506 18.2938 59.7162 18.2938C57.9624 18.2938 56.4076 17.6811 56.2088 15.5543H65.0496C65.0496 15.3199 65.0858 14.3828 65.0858 13.9502ZM56.1545 12.2379C56.1545 10.2012 57.4019 9.35412 58.5409 9.35412C59.6438 9.35412 60.819 10.2012 60.819 12.2379H56.1545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6744 5.69531C42.9027 5.69531 41.7637 6.5244 41.131 7.10116L40.8959 5.98369H36.9185V26.9993L41.4383 26.0441L41.4564 20.9434C42.1072 21.4119 43.0654 22.0788 44.6564 22.0788C47.8926 22.0788 50.8396 19.4835 50.8396 13.77C50.8214 8.54306 47.8383 5.69531 44.6744 5.69531ZM43.5898 18.1136C42.5231 18.1136 41.8903 17.7351 41.4564 17.2665L41.4383 10.5797C41.9083 10.0571 42.5592 9.69658 43.5898 9.69658C45.2349 9.69658 46.3739 11.535 46.3739 13.8961C46.3739 16.3112 45.2531 18.1136 43.5898 18.1136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6987 4.63209L35.2367 3.65881V0L30.6987 0.955257V4.63209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2367 6.00116H30.6987V21.7718H35.2367V6.00116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8355 7.33537L25.5463 6.00161H21.6411V21.7724H26.1609V11.0843C27.2276 9.69647 29.0355 9.94881 29.596 10.1471V6.00161C29.0174 5.78533 26.9022 5.3888 25.8355 7.33537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7957 2.09094L12.3843 3.02818L12.3662 17.4651C12.3662 20.1327 14.373 22.0972 17.0488 22.0972C18.5312 22.0972 19.616 21.827 20.2127 21.5026V17.8436C19.6342 18.078 16.7776 18.907 16.7776 16.2396V9.84114H20.2127V6.00209H16.7776L16.7957 2.09094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57408 10.5797C4.57408 9.87682 5.15262 9.60646 6.11081 9.60646C7.48485 9.60646 9.22047 10.021 10.5945 10.76V6.5244C9.09391 5.92962 7.61141 5.69531 6.11081 5.69531C2.44071 5.69531 0 7.60583 0 10.796C0 15.7706 6.87015 14.9776 6.87015 17.1223C6.87015 17.9515 6.14698 18.2218 5.13454 18.2218C3.63395 18.2218 1.71754 17.609 0.198873 16.78V21.0696C1.88025 21.7905 3.57971 22.0969 5.13454 22.0969C8.89503 22.0969 11.4804 20.2404 11.4804 17.0142C11.4623 11.6431 4.57408 12.5984 4.57408 10.5797Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_8007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.37241856404c3969a00d5d63c8e1c0bc.svg";
export { ForwardRef as ReactComponent };